import React, { useContext } from 'react';
import 'twin.macro';
import { AppContext } from '../context';
import { ArrowIcon, TimesIcon } from 'icons';
import { MainMenu } from '.';
import { gaEvent } from 'services/ga';
import { ItemModal } from '../item';
import { useSearchParams } from 'react-router-dom';
import { Button } from '../button';
import { TitleRow } from '../text';
import { ScrollBarContent } from '../scroll';

export const EmptyFragment = () => <></>;

export const MenuHeader = ({ children, noBackButton = false, title, ...restProps }) => {
  return (
    <div tw='bg-brand px-4 md:pt-6 sm:rounded-t-xl' className='group text-dark'>
      <TitleRow
        Type='h2'
        text={title}
        LeftBlock={noBackButton ? null : () => <BackToMenuButton />}
        RightBlock={() => <CloseMenuButton {...restProps} />}
      />
    </div>
  );
};

export const MenuFooter = ({ children }) => {
  return <div tw='bg-dark p-4 sm:rounded-b-xl contrast-125'>{children}</div>;
};

export const MenuContent = ({ children }) => {
  return (
    <>
      {/* TODO: ScrollBarContent uses LayoutEffect and renders only on client
          But we need ItemDetailsPage to be rendered on server to set meta tags */}
      <ScrollBarContent tw='bg-primary'>
        <div tw='mb-20 sm:mb-0 p-4 pt-6'>{children}</div>
      </ScrollBarContent>
      <MenuFooter />
    </>
  );
};

export const BackToMenuButton = () => {
  const { setSlideIn } = useContext(AppContext);
  return (
    <Button
      label='menu'
      data-action='back'
      iconProps={{ Type: ArrowIcon, color: 'dark', rotation: 'minus90' }}
      labelRight
      onClick={() => {
        gaEvent('dmp_action', 'menu_back_button');
        setSlideIn({
          active: true,
          fullwidth: false,
          Component: MainMenu,
        });
      }}
      noSpacing
    />
  );
};

export const CloseMenuButton = ({ modalId }) => {
  const { setSlideIn } = useContext(AppContext);
  const [, setSearchParams] = useSearchParams();
  const isItemModal = !!modalId;
  return (
    <Button
      label='sluiten'
      data-action='close'
      iconProps={{ Type: TimesIcon, color: 'dark' }}
      noSpacing
      onClick={() => {
        gaEvent('dmp_action', 'menu_close');
        if (isItemModal) {
          setSearchParams({ selectedId: modalId });
        }
        setSlideIn(
          isItemModal
            ? {
                fullwidth: true,
                active: true,
                Component: () => <ItemModal itemId={modalId} />,
              }
            : {
                fullwidth: false,
                active: false,
                Component: EmptyFragment,
              },
        );
      }}
    />
  );
};
